import './Select.scss'

import React, { useCallback, useEffect, useRef, useState } from 'react'

import { formEvent } from '../Form/Form'
import t from '../../helpers/i18n'

const Select = ({
  name,
  label,
  initialValue,
  required,
  ref,
  onChange,
  children
}) => {
  const [value, setValue] = useState(initialValue)
  const [errorMessage, setErrorMessage] = useState()
  const field = useRef()

  const handleChange = useCallback(() => {
    if (required && field.current.value === '') {
      setValue(null)
      if (onChange) onChange(null)
      setErrorMessage(t('* Requerido'))
    } else {
      setValue(field.current.value)
      if (onChange) onChange(field.current.value)
      setErrorMessage(false)
    }
  }, [required, onChange])

  useEffect(() => {
    if (ref) ref.current = value
    if (name) {
      field.current.dispatchEvent(
        formEvent({
          action: 'UPDATE',
          name,
          value
        })
      )
    }
  }, [ref, value, name])

  useEffect(() => {
    if (name) {
      field.current.dispatchEvent(
        formEvent({
          action: 'REQUIRED',
          name,
          required
        })
      )
    }
  }, [name, required])

  useEffect(() => {
    const element = field.current
    return () => {
      if (name) {
        element.dispatchEvent(
          formEvent({
            action: 'REMOVE',
            name
          })
        )
      }
    }
  }, [name])

  useEffect(handleChange, [handleChange])

  return (
    <div className="select">
      <label className="label-small-medium">{label}</label>
      <select
        ref={field}
        onChange={handleChange}
        defaultValue={initialValue}>
        {children}
      </select>
      { errorMessage && <span className="label-small-medium color-error">{errorMessage}</span> }
    </div>
  )
}

export default Select
